import { Box, Typography } from '@mui/material';
import { AppPlusMinus } from 'components/core/AppPlusMinus/AppPlusMinus';

interface BookingSettingsCounterProps {
  title: string;
  subtitle: string;
  value: number;
  setValue: (num: number) => void;
  maximumValue?: number;
  minimumValue?: number;
  disabled?: boolean;
}

export const BookingSettingsCounter = ({
  value,
  setValue,
  title,
  subtitle,
  maximumValue,
  minimumValue,
  disabled = false,
}: BookingSettingsCounterProps) => {
  const handleDecrease = () => {
    if (!value && value !== 0) return;
    setValue(Number(value) - 1);
  };

  const handleIncrease = () => {
    if (!value && value !== 0) return;
    setValue(Number(value) + 1);
  };

  return (
    <Box display="flex" justifyContent="space-between" alignItems="center" mb={3}>
      <Box>
        <Typography fontWeight={700}>{title}</Typography>
        <Typography fontSize={12}>{subtitle}</Typography>
      </Box>
      <Box width={140}>
        <AppPlusMinus
          label={''}
          handleDecrease={handleDecrease}
          handleIncrease={handleIncrease}
          value={Number(value) ?? 1}
          minimumValue={minimumValue}
          id={`${title}${subtitle}`}
          maximumValue={maximumValue}
          disabled={disabled}
        />
      </Box>
    </Box>
  );
};
